<template>
    <div class="kficon" v-if="!showkf"><a href="#" @click="showkf=true"><img src="/images/kficon.png"></a></div>
    <div class="kfbox" v-else>
        <div class="kfclose">
            <a href="#" @click="showkf=false"><img src="/images/kfclose.png"></a>
        </div>
        <div class="kfinfo">
            <div class="kfimg"><img src="/images/kf.jpg"></div>

            <dl>
                <dt>客服热线</dt>
                <dd>400-920-2725</dd>
            </dl>
            <dl>
                <dt>咨询邮箱</dt>
                <dd>TOKENGLISH<br>@tokenglish.com</dd>
            </dl>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ffkf',
        data() {
            return {
                showkf: false
            };
        }
    }
</script>
